<style lang="less" scoped>
    .query-title-div{
        width:150px !important;
    }
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="list-header-title-div">用户管理</div>
            <ZD-list-querys>
                 <template slot="inputs">
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">手机号/姓名/用户编号：</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.searchKey" placeholder="请输入内容" clearable @keyup.enter.native="getListData(pagination,true)"></el-input>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">角色状态</div>
                        <div class="query-inputs-div flex-1">
                            <el-select size="small" v-model="queryInfo.status" clearable>
                                <el-option v-for="(item,index) in statueArr" :label="item.configName" :value="item.configVal" :key="index"></el-option>
                            </el-select>
                        </div>
                    </div>
                </template>
                <template  slot="actions">
                    <button class="common-bg-button" @click="getListData(pagination,true)">搜 索</button>
                    <button class="common-empty-button" @click="reset()">重 置</button>
                </template>
            </ZD-list-querys>
            <div class="page-action-btns flex">
                <button class="common-bg-button" @click="listAddFun()">新 增</button>
                <button class="common-bg-button" @click="listEditFun()">编 辑</button>
                <button class="common-bg-button" @click="toResetPwd()">修改密码</button>
                <!-- <div class="flex-1"></div>
                <el-input size="small" style="width:320px;margin-right:10px;" class="list-serach-input" v-model="queryInfo.pileTypeName" placeholder="请输入手机号/姓名/用户编号" clearable></el-input>
                <button class="common-bg-button" @click="getListData(pagination,true)">搜索</button> -->
            </div>
            <!-- 表格 -->
            <div class="list-table">
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
            </div>
            <!-- 密码重置 -->
            <el-dialog title="密码重置" width="520px" :visible.sync="pwdResetObj.showDialog">
                <el-form :model="pwdResetObj.formInfo" ref="pwdResetRef" :rules="pwdResetObj.rules">
                    <el-form-item label="用户手机号" prop="userPhone">
                        {{userPhone}}
                    </el-form-item>
                    <el-form-item label="用户名" prop="userName">
                        {{userName}}
                    </el-form-item>
                    <el-form-item label="用户密码" prop="restPassWord">
                        <el-input v-model="pwdResetObj.formInfo.restPassWord" type="password" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checknewPassWord">
                        <el-input v-model="pwdResetObj.formInfo.checknewPassWord" type="password" size="small"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="pwdResetObj.showDialog = false" size="small">取 消</el-button>
                    <el-button type="primary" @click="submitPwdFrom('pwdResetRef')" size="small">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '' || value === undefined) {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.pwdResetObj.formInfo.restPassWord) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };

            return {
                pageConfig: pageConfig, // 页面配置
                tableData: [], // 表格数据
                selections: [], // 表格选项
                pagination: pageConfig.pagination,
                queryInfo: {},
                operates: {
					width: 220,
					fixed: "right",
					list: [
						
					]
                }, // 列操作按钮
                statueArr:[],
                pwdResetObj: {
                    showDialog: false,
                    formInfo: {},
                    rules: {
                        restPassWord: [{
                            required: true,
                            message: '请输入新密码',
                            trigger: 'blur'
                        }],
                        checknewPassWord: [{
                            required: true,
                            validator: validatePass,
                            trigger: 'blur'
                        }],
                    },
                },
                userPhone: '',
                userName: ''
            }
        },
        methods: {
            init() {
                this.getListData(this.pagination,true);
                this.getConfig();
            },
            // 获取表格数据
            getListData(pagination, reload = false) {
                let _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    this.pagination.current = 1;
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                _.queryInfo.corpNo = _.$store.state.corpNo;
                _.queryInfo.dealerNo = _.$store.state.userInfo.dealNo;
                _.$H.get(_, _.$A.user.list, _.queryInfo).then(res => {
                    _.tableData = res.data.data.content || [];
                    _.pagination.total = res.data.data.totalElements || 0;
                    _.$U.hideLoading(_);
                })
            },
            getConfig(){
                let _ = this;
                _.$H.post(_,_.$A.config.list,{configType:"192"}).then(res => {
                    _.statueArr = res.data.data;
                })
            },
            // 页面新增方法
            listAddFun() {
                this.$S.listAddFun(this, pageConfig.tableEditObj);
            },
            // 页面编辑方法
            listEditFun() {
                this.$S.tableEditFun(this, this.selections, pageConfig.tableEditObj);
            },
            reset(){
                this.pagination.current = 1;
                delete this.queryInfo.status;
                delete this.queryInfo.searchKey;
                this.getListData(this.pagination);
            },
            //密码修改
            toResetPwd() {
                this.userPhone = '';
                this.userName = '';
                this.pwdResetObj.formInfo = {};
                if(this.selections.length < 1){
                    this.$U.error('请选择需要操作的对象')
                }else if(this.selections.length > 1){
                    this.$U.error('只能选择一个操作的对象')
                }else{
                    this.pwdResetObj.showDialog = true;
                    this.userPhone = this.selections[0].userPhone;
                    this.userName = this.selections[0].userName;
                    this.pwdResetObj.formInfo.userId = this.selections[0].userId;
                }
            },
            //密码提交
            submitPwdFrom(formName) {
                    let _ = this;
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            var obj = {
                                restPassWord: _.pwdResetObj.formInfo.restPassWord,
                                userId: _.pwdResetObj.formInfo.userId
                            }
                            _.$H.post(_, _.$A.user.userPwdReset, obj).then(res => {
                                _.$U.success('修改成功')
                                _.pwdResetObj.showDialog = false;
                            })
                        }
                    });
            },
        },
        mounted() {
            this.init();
        }
    }
</script>